import React, { useEffect, useState } from "react";
import Header from "../components/common/header";
import { useParams } from "react-router-dom";
import Loader from "../components/common/Loader";
import ListComponent from "../components/Dashboard/ListComponent";
import { convertCoinObject } from "../functions/convertCoinObject";
import CoinInfo from "../components/coin/coinInfo";
import { getCoinData } from "../functions/getCoinData";
import { getCoinPrices } from "../functions/getCoinPrices";
import LineChart from "../components/coin/LineChart";
import SelectDays from "../components/common/SelectDays";
import { getChartDataSet } from "../functions/getChartDataSet";
import ToggleComponent from "../components/common/ToggleButton";

function CoinPage() {
  const { id } = useParams();
  const [detailLoading, setDetailLoading] = useState(true);
  const [coinData, setCoinData] = useState({});
  const [days, setDays] = useState(30);
  const [dataSet, setDataSet] = useState({});
  const [priceType, setPriceType] = useState("current_price");

  /* Coin metadata only when route id changes — not on days / priceType. */
  useEffect(() => {
    if (!id) return undefined;

    let cancelled = false;
    setDetailLoading(true);

    (async () => {
      const data = await getCoinData(id);
      if (cancelled) return;
      if (data) {
        convertCoinObject(setCoinData, data);
      }
      if (!cancelled) setDetailLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [id]);

  /* Chart series when id or chart controls change — no repeat getCoinData. */
  useEffect(() => {
    if (!id) return undefined;

    let cancelled = false;

    (async () => {
      const pricesData = await getCoinPrices(id, days, priceType);
      if (cancelled) return;
      if (Array.isArray(pricesData) && pricesData.length > 0) {
        setDataSet(getChartDataSet(pricesData, "#8a3ffc"));
      } else {
        setDataSet({});
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [id, days, priceType]);

  const showPageLoader = detailLoading || (id && !coinData?.id);

  return (
    <div>
      <Header />
      {showPageLoader ? (
        <Loader />
      ) : (
        <div>
          <div className="grey-wrapper">
            <ListComponent coin={coinData} />
          </div>
          <div className="grey-wrapper">
            <SelectDays days={days} setDays={setDays} />
            <ToggleComponent priceType={priceType} setPriceType={setPriceType} />
            <LineChart priceType={priceType} chartData={dataSet} />
          </div>
          <CoinInfo heading={coinData.name} desc={coinData.desc} />
        </div>
      )}
    </div>
  );
}

export default CoinPage;
